import { IconButton } from '@mui/material';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

import DeleteModal from '@Components/Modal/DeleteModal';
import { useDisclosure } from '@hooks/useDisclosure';
import { useNatureOfBusinessForm } from '@Router/NatureOfBusiness/Containers/NatureOfBusinessFormProvider';
import { IIncomeStructureFormValues } from '@Router/NatureOfBusiness/Containers/NatureOfBusinessFormProvider/types';

type OtherIncomeDeleteButtonProps = {
  keyItem: string;
};

const OtherIncomeDeleteButton = ({ keyItem }: OtherIncomeDeleteButtonProps) => {
  const [opened, { open, close }] = useDisclosure();
  const { getValues, unregister, watch } = useNatureOfBusinessForm();

  const completedSection = watch(
    'incomeStructure.completedSection'
  ) as IIncomeStructureFormValues['completedSection'];
  const { isCompletedTh = false, isCompletedEn = false } =
    completedSection ?? {};

  const otherIncomeItems = getValues(
    'incomeStructure.otherIncomeItems'
  ) as IIncomeStructureFormValues['otherIncomeItems'];
  const topicTh = otherIncomeItems[keyItem].incomeCategory?.nameTh ?? '';

  const handleDelete = () => {
    unregister(`incomeStructure.otherIncomeItems.${keyItem}`);
    close();
  };

  return (
    <>
      <IconButton
        color="inherit"
        size="small"
        sx={{ padding: 0 }}
        onClick={open}
        disabled={isCompletedTh || isCompletedEn}
      >
        <DeleteOutlineIcon style={{ fontSize: '14px' }} />
      </IconButton>
      <DeleteModal
        topic={topicTh}
        opened={opened}
        close={close}
        confirm={handleDelete}
      />
    </>
  );
};

export default OtherIncomeDeleteButton;
